module.exports = __webpack_public_path__ + "sa.svg?1c14b2ed39388b5bf16aa85c4b6d50bb";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/sa.svg
// module id = 1340
// module chunks = 0